<div class="portal-teaser layout-{{row.layout}}" *ngFor="let row of data">
  <h2 [innerHTML]="row.headline"></h2>
  <div class="image-wrapper" *ngIf="row.image">
    <div class="image">
      <img [src]="row.image" alt="">
      <span class="copyright" *ngIf="row.copyright" [innerHTML]="row.copyright"></span>
    </div>
  </div>
  <div class="content-wrapper" [innerHTML]="row.content"></div>
  <div class="cta-wrapper" *ngIf="row.url && row.buttontext">
    <a role="button" [href]="row.url" class="button primary" target="_blank" [innerHTML]="row.buttontext"></a>
  </div>
</div>
